var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09559 4.21053C2.09559 1.88842 3.97533 0 6.28676 0C8.59819 0 10.4779 1.88842 10.4779 4.21053C10.4779 6.53263 8.59819 8.42105 6.28676 8.42105C3.97533 8.42105 2.09559 6.53263 2.09559 4.21053ZM9.73819 9.32421C9.27088 9.20421 8.75955 9.27158 8.33834 9.50737C7.06632 10.2189 5.5093 10.2189 4.23728 9.50737C3.81606 9.27158 3.30474 9.20632 2.83743 9.32421C1.16515 9.74737 0 11.2695 0 13.0253V13.8758C0 14.4126 0.1425 14.9389 0.412831 15.3958C0.632867 15.7684 1.0457 16 1.48996 16H11.0815C11.5257 16 11.9386 15.7684 12.1586 15.3958C12.4289 14.9389 12.5714 14.4126 12.5714 13.8758V13.0253C12.5714 11.2695 11.4063 9.74737 9.7361 9.32421H9.73819Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullName);
export default __webpack_public_path__ + "static/media/full-name.94fd80a28cffda10670be25903678990.svg";
export { ForwardRef as ReactComponent };